import { render, staticRenderFns } from "./packageForm.vue?vue&type=template&id=5ddf62b6&scoped=true"
import script from "./packageForm.vue?vue&type=script&lang=js"
export * from "./packageForm.vue?vue&type=script&lang=js"
import style0 from "./packageForm.vue?vue&type=style&index=0&id=5ddf62b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddf62b6",
  null
  
)

export default component.exports